import { Fragment } from "react";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeaderTwo from "../../component/layout/pageheader-2";
import Author from "../../component/sidebar/author";
import Comment from "../../component/sidebar/comment";
import CourseSideCetagory from "../../component/sidebar/course-cetagory";
import CourseSideDetail from "../../component/sidebar/course-detail";
import Respond from "../../component/sidebar/respond"; 
import Beginner from "../../component/layout/Sing/beginner";


const BeginnerVocalSingle = () => {

    // ---------- Tutor List for Singing Category ----------
    const tutors = [
        {
            name: "Anjali Sharma",
            expertise: "Classical & Light Vocal",
            experience: "5 Years Experience",
        },
        {
            name: "Rahul Verma",
            expertise: "Western Vocal & Pop Singing",
            experience: "3 Years Experience",
        },
        {
            name: "Meera Joshi",
            expertise: "Carnatic Vocal Trainer",
            experience: "7 Years Experience",
        },
    ];

    return (
        <Fragment>
            <Header />
            {/* <Beginner title="Beginner Singing Course" /> */}

            <div className="course-single-section padding-tb section-bg" style={{ backgroundColor: "#F5F0FF" }}>
                <div className="container">
                    <div className="row justify-content-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-8">
                            <div className="main-part">
                                <div className="course-item">
                                    <div className="course-inner">
                                        <div className="course-content">
                                            <h3>Beginner Singing Course – Overview</h3>
                                            <p>This course helps you discover your natural voice, improve vocal clarity, and understand basic singing techniques. Perfect for beginners.</p>

                                            <h4>What You'll Learn:</h4>
                                            <ul className="lab-ul" style={{ color: "black" }}>
                                                <li><i className="icofont-tick-mark"></i>Breathing Techniques</li>
                                                <li><i className="icofont-tick-mark"></i>Warm-ups for Beginner Singers</li>
                                                <li><i className="icofont-tick-mark"></i>Understanding Pitch & Scale</li>
                                                <li><i className="icofont-tick-mark"></i>Improving Vocal Tone</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* Course Video */}
                                <div className="course-video">
    <div className="course-video-title">
        <h4>Course Content</h4>
    </div>

    <div className="course-video-content">
        <div className="accordion" id="BeginnerVocalAcc">
            <div className="accordion-item">
                <div className="accordion-header" id="bv01">
                    <button className="d-flex justify-content-between" data-bs-toggle="collapse" data-bs-target="#videolist1" aria-expanded="true" aria-controls="videolist1">
                        <span>1. Vocal Basics</span>
                        <span>5 Lessons</span>
                    </button>
                </div>

                <div id="videolist1" className="accordion-collapse collapse show" aria-labelledby="bv01" data-bs-parent="#BeginnerVocalAcc">
                    <ul className="lab-ul video-item-list">
                        <li className="d-flex flex-wrap justify-content-between">
                            <div className="video-item-title" style={{ color: "black" }}>1.1 Welcome to the course – 02:30 minutes</div>
                            <div className="video-item-icon">
                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                    <i className="icofont-play-alt-2"></i>
                                </a>
                            </div>
                        </li>
                        <li className="d-flex flex-wrap justify-content-between">
                            <div className="video-item-title" style={{ color: "black" }}>1.2 Breathing Techniques – 03:45 minutes</div>
                            <div className="video-item-icon">
                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                    <i className="icofont-play-alt-2"></i>
                                </a>
                            </div>
                        </li>
                        <li className="d-flex flex-wrap justify-content-between">
                            <div className="video-item-title" style={{ color: "black" }}>1.3 Warm-ups for Beginners – 04:12 minutes</div>
                            <div className="video-item-icon">
                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                    <i className="icofont-play-alt-2"></i>
                                </a>
                            </div>
                        </li>
                        <li className="d-flex flex-wrap justify-content-between">
                            <div className="video-item-title" style={{ color: "black" }}>1.4 Pitch & Scale Exercises – 05:20 minutes</div>
                            <div className="video-item-icon">
                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                    <i className="icofont-play-alt-2"></i>
                                </a>
                            </div>
                        </li>
                        <li className="d-flex flex-wrap justify-content-between">
                            <div className="video-item-title" style={{ color: "black" }}>1.5 Daily Practice Routine – 06:00 minutes</div>
                            <div className="video-item-icon">
                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                    <i className="icofont-play-alt-2"></i>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>


                                {/* ---------- Tutors Section ---------- */}
                                <div style={{ marginTop: "40px", padding: "20px", background: "#FFFFFF", borderRadius: "10px" }}>
                                    <h3 style={{ marginBottom: "20px" }}>Singing Tutors</h3>

                                    {tutors.map((tutor, index) => (
                                        <div key={index} style={{ padding: "15px", borderBottom: "1px solid #ddd" }}>
                                            <h5 style={{ margin: 0 }}>{tutor.name}</h5>
                                            <p style={{ margin: "5px 0" }}>{tutor.expertise}</p>
                                            <small style={{ color: "#666" }}>{tutor.experience}</small>
                                        </div>
                                    ))}
                                </div>
                                {/* ---------- End Tutors Section ---------- */}

                                <Author />
                                <Comment />
                                <Respond />
                            </div>
                        </div>

                        {/* RIGHT SIDEBAR */}
                        <div className="col-lg-4">
                            <div className="sidebar-part">
                                <CourseSideDetail />
                                <CourseSideCetagory />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default BeginnerVocalSingle;
